// src/components/RequireLocation.js
import React, { useContext } from 'react';
import { LocationContext } from '../context/LocationContext';
import Spinner from './Spinner';
import './RequireLocation.css';

export default function RequireLocation({ children }) {
  const { loading } = useContext(LocationContext);

  if (loading) {
    return (
      <div className="require-location-overlay">
        <Spinner
          size={222}
          spinnerText=""
          showEllipses={false}
          pulseScale={1.008}
          pulseDuration={1}
          textCycleDuration={1.6}
          textColor="black"
          textSize="0.7rem"
          textOffsetX="-12px"
          textOffsetY="20px"
          containerOffsetY="-80%"
        />
        <div className="require-location-text">
          Solicitando permiso de ubicación…
        </div>
      </div>
    );
  }

  // Una vez loading===false, renderiza los hijos
  return <>{children}</>;
}
